var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#496E2D"
    },
    d: "M437.027,437.027c96.011-96.011,99.802-249.296,11.413-349.855l-192.44,168.827L87.172,448.44 C187.731,536.829,341.015,533.038,437.027,437.027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M74.974,74.974c96.011-96.011,249.296-99.802,349.855-11.413L256,256.003L63.562,424.829 C-24.828,324.27-21.036,170.985,74.974,74.974z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M424.827,63.56L63.56,424.828c3.652,4.155,7.444,8.231,11.413,12.198 c3.968,3.968,8.045,7.76,12.201,11.414L448.439,87.172c-3.652-4.156-7.445-8.232-11.414-12.201 C433.059,71.005,428.982,67.212,424.827,63.56z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "107.861,89.036 113.388,106.043 131.269,106.043 116.803,116.552 122.328,133.559  107.861,123.048 93.394,133.559 98.921,116.552 84.454,106.043 102.336,106.043  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "199.2,89.036 204.727,106.043 222.607,106.043 208.141,116.552 213.667,133.559  199.2,123.048 184.733,133.559 190.26,116.552 175.793,106.043 193.674,106.043  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "107.861,178.083 113.388,195.09 131.269,195.09 116.803,205.6 122.328,222.607  107.861,212.096 93.394,222.607 98.921,205.6 84.454,195.09 102.336,195.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "199.2,178.083 204.727,195.09 222.607,195.09 208.141,205.6 213.667,222.607 199.2,212.096  184.733,222.607 190.26,205.6 175.793,195.09 193.674,195.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "153.531,133.559 159.058,150.566 176.938,150.566 162.472,161.076 167.998,178.083  153.531,167.572 139.064,178.083 144.59,161.076 130.123,150.566 148.005,150.566  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSb);
export default __webpack_public_path__ + "static/media/sb.090365955f6c398aa2e5bcaeb6010d73.svg";
export { ForwardRef as ReactComponent };